var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwalLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 92,
    viewBox: "0 0 91 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5602 91.2099C70.6339 91.2099 90.9602 70.8836 90.9602 45.8099C90.9602 20.7362 70.6339 0.409912 45.5602 0.409912C20.4864 0.409912 0.160156 20.7362 0.160156 45.8099C0.160156 70.8836 20.4864 91.2099 45.5602 91.2099Z",
    fill: "#D0D5DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8217 33.96C52.8217 33.44 53.0617 32.93 53.5117 32.6C54.2617 32.05 55.3117 32.22 55.8617 32.97L64.4817 44.82C64.9117 45.41 64.9117 46.21 64.4817 46.8L55.8617 58.65C55.3117 59.4 54.2617 59.57 53.5117 59.02C52.7617 58.47 52.5917 57.41 53.1417 56.67L61.0417 45.81L53.1417 34.95C52.9217 34.65 52.8217 34.31 52.8217 33.96Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2012 45.8099C35.2012 44.8799 35.9512 44.1299 36.8812 44.1299H63.1212C64.0512 44.1299 64.8012 44.8799 64.8012 45.8099C64.8012 46.7399 64.0512 47.4899 63.1212 47.4899H36.8812C35.9512 47.4899 35.2012 46.7399 35.2012 45.8099Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3105 60.5299V31.0999C26.3105 30.1699 27.0606 29.4199 27.9906 29.4199C28.9206 29.4199 29.6705 30.1699 29.6705 31.0999V60.5299C29.6705 61.4599 28.9206 62.2099 27.9906 62.2099C27.0606 62.2099 26.3105 61.4599 26.3105 60.5299Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3105 60.5299C26.3105 59.5999 27.0606 58.8499 27.9906 58.8499H35.4406C36.3706 58.8499 37.1205 59.5999 37.1205 60.5299C37.1205 61.4599 36.3706 62.2099 35.4406 62.2099H27.9906C27.0606 62.2099 26.3105 61.4599 26.3105 60.5299Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3105 31.0899C26.3105 30.1599 27.0606 29.4099 27.9906 29.4099H35.4406C36.3706 29.4099 37.1205 30.1599 37.1205 31.0899C37.1205 32.0199 36.3706 32.7699 35.4406 32.7699H27.9906C27.0606 32.7699 26.3105 32.0199 26.3105 31.0899Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwalLogout);
export default __webpack_public_path__ + "static/media/swalLogout.b49c2c2b7e122efbd9f0bcdd1836aba8.svg";
export { ForwardRef as ReactComponent };